import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { updateViewId } from "../store/actions/appConfig";
import { smeBaseName } from "../routes";

export const useViewId = (isSendToApi = false) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { pathname } = useLocation();

  const viewId = pathname.replace(`/${id}`, "").replace(smeBaseName, "");

  useEffect(() => {
    dispatch(updateViewId(viewId, isSendToApi));
  }, [dispatch, pathname, isSendToApi, viewId]);
};
